import React from 'react'
import IntroContainer from 'src/containers/Top/Intro'

const IntroPage: React.FC = () => {
  return <IntroContainer />
}

export const PATH = '' as const
export default IntroPage
